import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=8d9b7fa2"
import script from "./ViewDetail.vue?vue&type=script&lang=ts"
export * from "./ViewDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports